import React from "react";
import { RootStateOrAny, useSelector, useDispatch } from "react-redux";
import { Panel } from "office-ui-fabric-react";
import { panelS } from "../../../features/common/styles/panelStyles";
import {
  setSelectedListItem,
  toggleReceptionPlacePanel,
} from "../../../config/redux/client/clientActions";
import ReceptionPlaceForm from "../forms/ReceptionPlaceForm";
import ReceptionDataDisplay from "../display/ReceptionDataDisplay";
import { useTranslation } from "react-i18next";

export interface ReceptionPlacePanelProps {
  predefinedItemData?: any;
}

const ReceptionPlacePanel: React.FC<ReceptionPlacePanelProps> = ({
  predefinedItemData,
}) => {
  const dispatch = useDispatch();
  const { receptionPlacePanelOpen, formActive, selectedItem } = useSelector(
    (state: RootStateOrAny) => state.client
  );

  const dismissPanel = () => {
    dispatch(
      toggleReceptionPlacePanel({ isOpen: false, formActive: formActive })
    );
    dispatch(setSelectedListItem(""));
  };

  const { t } = useTranslation("receptionPlaces");
  const panelName: string = t("receptionPlace");
  
  return (
    <Panel
      isOpen={receptionPlacePanelOpen}
      closeButtonAriaLabel="Close"
      headerText={panelName}
      onDismiss={dismissPanel}
      type={1}
      styles={panelS}
      isHiddenOnDismiss={false}
    >
      {formActive && <ReceptionPlaceForm predefinedInitValues={predefinedItemData} />}
      {!formActive && selectedItem && (
        <ReceptionDataDisplay selectedItem={!!selectedItem && Object.keys(selectedItem).length > 0 ? selectedItem : (!!predefinedItemData ? predefinedItemData : selectedItem)} />
      )}
    </Panel>
  );
};

export default ReceptionPlacePanel;